var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
/**
 * Viewport-aware collision behavior for the `Popup` paired with an inline-edit dropdown trigger
 * (`InlineSelect`, `InlineVisibilitySelect`, and any future dropdown-variant inline-edit component).
 * `Popup` already flips above the anchor when there is no room below (`vertical: 'flip'`) and caps
 * `max-height` with scroll when neither side fits — this constant just opts every dropdown-style
 * inline-edit consumer into that existing behavior instead of `Popup`'s strict-placement default.
 */
export const INLINE_EDIT_POPUP_COLLISION = { horizontal: 'fit', vertical: 'flip' };
export function InlineEditDropdown(_a) {
    var { as, children, className, width = 'auto', multiline = false, disableEdit = false, id, onClick, refComp } = _a, props = __rest(_a, ["as", "children", "className", "width", "multiline", "disableEdit", "id", "onClick", "refComp"]);
    const Component = as || 'div';
    const variantClass = 'qmb-ui-inline-edit--dropdown';
    const widthClass = width === 'full' ? 'qmb-ui-inline-edit--x-full' : '';
    const multilineClass = multiline ? 'qmb-ui-inline-edit--multiline' : '';
    const handleClick = () => {
        if (!disableEdit && onClick) {
            onClick();
        }
    };
    return (React.createElement(Component, Object.assign({ id: id, ref: refComp, className: classNames({ [variantClass]: !disableEdit }, widthClass, multilineClass, className), onClick: handleClick, tabIndex: disableEdit ? undefined : 0 }, props), children));
}
